import gql from 'graphql-tag';

export default gql`
mutation($type: String!) {
  setPageType(type: $type) @client
}
`;
